import {Selectors} from "@core/store/selectors";
import {Theme} from "@emotion/react";
import {
  Autocomplete,
  Box,
  SxProps,
  TextField,
  TextFieldVariants,
} from "@mui/material";
import {useSelector} from "react-redux";
import {useEffect, useState} from "react";
import {getUserText, translate} from "@util";
import {UserAvatar} from "./UserAvatar";
import {Role} from "@core/model";

const UserSelector = ({
  value: valueProp,
  sx,
  label,
  variant,
  disabled,
  roles = ["OPERATOR"],
  onChange,
}: {
  value?: string;
  sx?: SxProps<Theme>;
  label?: string;
  variant?: TextFieldVariants;
  disabled?: boolean;
  roles?: Role[];
  onChange: (id: string | undefined) => void;
}) => {
  const users = useSelector(Selectors.users) ?? [];
  const [value, setValue] = useState<{id: string; label: string}>();

  useEffect(() => {
    const u = users.find(u => u.id === valueProp);
    if (u) {
      setValue({id: u.id, label: getUserText(u)});
    }
  }, [valueProp, users]);

  return (
    <>
      <Autocomplete
        sx={{...sx, overflow: "hidden"}}
        disabled={disabled}
        value={value ?? null}
        onChange={(_event, newValue) => {
          onChange(newValue?.id);
        }}
        options={users
          .filter(u => roles.includes(u.role))
          .map(u => ({id: u.id, label: getUserText(u)}))}
        renderInput={params => (
          <TextField
            {...params}
            label={label ? translate(label) : undefined}
            variant={variant ?? "standard"}
          />
        )}
        renderOption={(props, option) => {
          const {key, ...optionProps} = props;
          return (
            <Box component={"li"} key={key} {...optionProps}>
              <UserAvatar id={option.id} sx={{mr: 1}} width={24} />
              {option.label}
            </Box>
          );
        }}
      />
    </>
  );
};

export {UserSelector};
